import { createSelector } from 'reselect'
import { SendReconciliationSSOEmailStatus } from './SendReconciliationSSOEmailStatus'

export const isAuthentified = state => !!state.auth.tokens
export const getAuthTokens = state => state.auth.tokens
export const getApiToken = createSelector(
  getAuthTokens,
  tokens => tokens && tokens.apiToken
)
export const getAuthError = state => state.auth.error

const defaultSendReconciliationSSOEmailStatus = new SendReconciliationSSOEmailStatus()
export const getSendReconciliationSSOEmailStatus = (state, userId) =>
  state.auth.sendReconciliationSSOEmailStatuses.get(userId) ||
  defaultSendReconciliationSSOEmailStatus
